import PropTypes from 'prop-types';

import Link from 'shopper/components/Link';

import placeholder from 'lib/placeholder';

const RepliesPaginationLink = ({ onPaginate }) => (
  <div className="flex items-center justify-center py-6">
    <Link
      className="dark:text-neutral-high-100"
      size="size2"
      bold
      onClick={onPaginate}
    >
      {placeholder('actions.loadMore')}
    </Link>
  </div>
);

RepliesPaginationLink.propTypes = {
  onPaginate: PropTypes.func.isRequired,
};

export default RepliesPaginationLink;
